import { formatNumber } from '@/helpers';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import React from 'react';
export const DoughnutChartLabels = ({ label, color, amount }) => {
    const theme = useTheme();
    const formattedAmount = formatNumber(amount);
    return (React.createElement(Stack, { direction: "row", spacing: 2, alignItems: "center", sx: { height: '67px', py: '8px' } },
        React.createElement(Box, { sx: { flex: 0, height: '100%' } },
            React.createElement(Box, { component: "div", sx: {
                    borderRadius: theme.shape.borderRadius,
                    height: '100%',
                    width: '4px',
                    backgroundColor: color,
                } })),
        React.createElement(Box, { sx: {
                flexDirection: 'column',
                height: '100%',
                flex: '1 0 auto',
                display: 'flex',
                minWidth: '66px',
                pr: '8px',
            } },
            React.createElement(Typography, { sx: {} }, label),
            React.createElement(Typography, { sx: { fontWeight: theme.typography.fontWeightSemiBold } }, `$${formattedAmount}`))));
};
